export default {
  VIDEOS: "वीडियोज़",
  VIDEO: "वीडियो",
  BACKTOVIDEOS: "विडिओ लिस्ट पर वापस जाएं",
  WATCHOTHERVIDEOS: "अन्य वीडियोज़ देखें",
};
